import {styled} from '@mui/material'
import CustomButton from "../../../../customs/Button";

interface EmailTemplateDeleteProps {
  cancel: (parmeter: boolean) => void;
}

const EmailTemplateDelete = ({cancel}: EmailTemplateDeleteProps) => {

    return(
       <EmailTemplateDeleteContainer>
          <div className='body'>You are about to delete email template for Training Invitation? </div>
          <ButtonWrapper>
               <ButtonContainer>
                   <span onClick = {() => cancel(false)}>Cancel</span>
                   <StyledButton type="submit" text='Yes, delete'/>
               </ButtonContainer>
           </ButtonWrapper>
       </EmailTemplateDeleteContainer>
    )
   }

   export default EmailTemplateDelete;


const EmailTemplateDeleteContainer = styled('div')`
  padding: 40px;

  & span {
    cursor: pointer;
  }

  & .body {
    font-weight: 400;
    font-size: 24px;
    line-height: 40px;
    color: #232323;
  }

  & button {
    background: #DD5151;
  }
`




const ButtonWrapper = styled('div')`
      display: flex;
      justify-content: flex-end;
      margin-block: 2.5rem;
  `
  
const ButtonContainer = styled('div')`
      display: flex;
      gap: 2rem;
      align-items: center;
  `
  
  const StyledButton = styled(CustomButton)`
      padding-block: 1rem;
      padding-inline: 2rem;
  `
  const SubWrapper = styled('div')`
    display: flex;
    gap: 40px;
  `